// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__PoR32","savePackageButton":"ClientWallet_savePackageButton__1Cr2d"};